import styled, { keyframes } from 'styled-components'

import { ReactComponent as ErrorIcon } from 'static/svg/error-icon.svg'
import { ReactComponent as CheckIcon } from 'static/svg/icon-check-green.svg'
import { Typography } from '@telavita-core/react-design-kit'

const pulseAnimation = keyframes`
    0% { 
        opacity: 0.5;
    }
    50% { 
        opacity: 1.0;
    }
    100% { 
        opacity: 0.5;
    }
`

export const StyledErrorIcon = styled(ErrorIcon)`
  margin-bottom: 10px;
`
export const StyledCheckIcon = styled(CheckIcon)`
  height: 50px;
  width: 50px;
  margin-bottom: 10px;
`

export const Title = styled(Typography)`
  font-size: 21px;
  text-align: center;
  line-height: 25px;
  font-weight: 500;
  width: 332px;
`

export const PulseTitle = styled(Title)`
  -webkit-animation: ${pulseAnimation} 1s ease-out;
  -webkit-animation-iteration-count: infinite;
  opacity: 0.5;
`

export const Text = styled(Typography)`
  margin: 20px 0 5px 0;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`

export const HelperText = styled.span`
  line-height: 15px;
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
  display: block;
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
  gap: 20px;
`

export const InputContainer = styled.div`
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 100%;
  margin-top: 20px;

  input[type="file"] {
    cursor: pointer;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
  }
`

export const SpinnerContainer = styled.div`
  background: #2036b5;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  margin-bottom: 10px;
  .RequestTreatmentModal__Spinner {
    height: 27px !important;
    width: 27px !important;
    border-width: 3px !important;
    border-color: #fff !important;
    border-top-color: transparent !important;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
`
